import { render, staticRenderFns } from "./equipedWeaponsChartByTensionBeats.vue?vue&type=template&id=8c2fd3e4"
import script from "./equipedWeaponsChartByTensionBeats.vue?vue&type=script&lang=js"
export * from "./equipedWeaponsChartByTensionBeats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports